export const handleDatesSet = (
  info,
  selectedRooms,
  accessToken,
  setEvents,
  setStartDate,
  setEndDate
) => {
  const startDate = new Date(info.startStr);
  const firstDayOfMonth = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    startDate.getFullYear(),
    startDate.getMonth() + 2,
    2
  );
  setStartDate(firstDayOfMonth);
  setEndDate(lastDayOfMonth);
};

export const selectStyles = {
  backgroundColor: "#FFFFFF",
  borderColor: "#f2f0f0",
  borderWidth: "2px",
  borderStyle: "solid",
  fontSize: "18px",
  fontWeight: "500",
  color: "#5F6D7E",
  fontFamily: "Source Sans Pro, sans-serif",
  width: "520px",
  height: "55px",
  borderRadius: "8px",
  padding: "6px 5px",
  border: "1px solid #D1D9E2 !important",
  boxShadow: "none",
  "&:focus": {
    border: "0 !important",
  },
};

export const postData = (eventType, formValues) => {
  switch (eventType) {
    case "therapy":
      return {
        eventType: formValues.eventType,
        date: formValues.date,
        timeFrom: formValues.timeFrom,
        timeTo: formValues.timeTo,
        description: formValues.description,
        roomId: formValues.roomId,
        clientId: formValues.clientId,
        clientOutsideIPD: formValues.outsideClient,
      };
    case "individual_supervision":
      return {
        eventType: formValues.eventType,
        supervisionType: "individual",
        name: formValues.name,
        date: formValues.date,
        timeFrom: formValues.timeFrom,
        timeTo: formValues.timeTo,
        description: formValues.description,
        roomId: formValues.roomId,
        clientId: formValues.clientId,
        clientName: formValues.outsideClient,
      };
    case "other":
      return {
        eventType: formValues.eventType,
        name: formValues.name,
        date: formValues.date,
        timeFrom: formValues.timeFrom,
        timeTo: formValues.timeTo,
        description: formValues.description,
        roomId: formValues.roomId,
      };
    default:
      return [];
  }
};

export const putData = (eventType, formValues) => {
  switch (eventType) {
    case "therapy":
      return {
        eventType: formValues.eventType,
        eventId: formValues.eventId,
        date: formValues.date,
        timeFrom: formValues.timeFrom,
        timeTo: formValues.timeTo,
        description: formValues.description,
        roomId: formValues.roomId,
        clientId: formValues.clientId,
        clientOutsideIPD: formValues.outsideClient,
      };
    case "individual_supervision":
      return {
        eventType: formValues.eventType,
        eventId: formValues.eventId,
        supervisionType: "individual",
        name: formValues.name,
        date: formValues.date,
        timeFrom: formValues.timeFrom,
        timeTo: formValues.timeTo,
        description: formValues.description,
        roomId: formValues.roomId,
        clientId: formValues.clientId,
        clientName: formValues.outsideClient,
      };
    case "other":
      return {
        eventType: formValues.eventType,
        eventId: formValues.eventId,
        name: formValues.name,
        date: formValues.date,
        timeFrom: formValues.timeFrom,
        timeTo: formValues.timeTo,
        description: formValues.description,
        roomId: formValues.roomId,
      };
    default:
      return [];
  }
};

export const transformEventName = (eventType) => {
  switch (eventType) {
    case "therapy":
      return "Terapija";
    case "individual_supervision":
      return "Supervizija";
    case "other":
      return "Ostalo";
    default:
      return "Event";
  }
};

export const addOneHourToTime = (time) => {
  const [hours, minutes] = time.split(":").map(Number);

  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  date.setHours(date.getHours() + 1);

  const newHours = String(date.getHours()).padStart(2, "0");
  const newMinutes = String(date.getMinutes()).padStart(2, "0");

  return `${newHours}:${newMinutes}`;
};

export const getUsersName = (allUsers, userId, event) => {
  const user = allUsers?.find((user) => user.id === userId);
  if (!user) {
    const resp =
      event?.clientOutsideIPD?.length > 0
        ? event.clientOutsideIPD
        : transformEventName(event.eventType);
    return resp;
  }
  return user?.firstName + " " + user?.lastName;
};

export const getTitle = (event, userId, allUsers) => {
  if (event?.name) return event.name;

  if (userId === event.supervisorId || userId === event.therapistId) {
    return getUsersName(allUsers, event.clientId, event);
  }

  if (event.supervisorId)
    return getUsersName(allUsers, event.supervisorId, event);
  if (event.therapistId)
    return getUsersName(allUsers, event.therapistId, event);

  return transformEventName(event?.eventType) || "Unnamed Event";
};

export const adjustDate = (date, reference, changeDate) => {
  if (!(date instanceof Date) || isNaN(date)) return null;
  const offset = reference > changeDate ? -2 : 0;
  date.setHours(date.getHours() + offset);
  return date.toISOString();
};

export const filterByCity = (allRooms, selectedCity, setRooms) => {
  const filteredRooms = allRooms?.filter(
    (room) => room.cityId === selectedCity?.value
  );
  setRooms(filteredRooms);
};
